import React from 'react';
import Navbar from '../components/Navbar';
import RolePlayHero from '../components/roleplay/RolePlayHero';
import RolePlayCTA from '../components/roleplay/RolePlayCTA';
import Footer from '../components/Footer';
import AnimatedBackgroundDirectional from '../components/AnimatedBackgroundDirectional';
import SEO from '../components/SEO';

const RolePlayPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <SEO 
        title="AI Role-Play Platform - Traain Performance IQ"
        description="Practice critical conversations with AI-powered role-play simulations. Build confidence in customer service, sales, de-escalation, and leadership scenarios."
        keywords="AI roleplay coaching, sales roleplay, customer service training, AI simulation, soft skills training, conversation practice"
      />
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <AnimatedBackgroundDirectional direction="diagonal" />
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <RolePlayHero />
        <RolePlayCTA />
        <Footer />
      </div>
    </div>
  );
};

export default RolePlayPage;
